import { combineReducers } from 'redux';
import aesReduxConstants from '../constants';

const mapPinReducer = function() {
  const constants = aesReduxConstants.MAP;


  const contentReducer = function(actionPrefix) {
    return function(state, action) {
      const addPrefix = function(actionType) {
        return actionPrefix + actionType;
      };

      const defaultState = null;
      if (state === undefined) state = defaultState;

      switch (action.type) {
        case addPrefix(constants.DROP_POINT):
          return {
            title: action.title,
          };

        default:
          return state;
      }
    };
  };

  const coordinatesReducer = function(actionPrefix) {
    return function(state, action) {
      const addPrefix = function(actionType) {
        return actionPrefix + actionType;
      };

      const defaultState = null;
      if (state === undefined) state = defaultState;

      switch (action.type) {
        case addPrefix(constants.DROP_POINT):
          return action.coordinates;

        default:
          return state;
      }
    };
  };

  // actionPrefix allowes for being able to reuse
  // this logic to "drop pins" in other places in
  // the redux store look at aes-redux/reducers/mapQuickSearchReducer.js
  // for an example
  return function(actionPrefix) {
    return combineReducers({
      content: contentReducer(actionPrefix),
      coordinates: coordinatesReducer(actionPrefix),
    });
  };
};


export default mapPinReducer();
